// extracted by mini-css-extract-plugin
module.exports = {"empty":"_13823","message":"_5129","actions":"_10806","noMargin":"_19237"};